import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelCase',
  standalone: true
})
export class CamelCasePipe implements PipeTransform {
  private isWordChar(char: string): boolean {
    return /[a-zA-Z0-9\-/]/.test(char);
  }

  private splitTrailingPunctuation(word: string): { cleanWord: string; trailingPunctuation: string } {
    let index = word.length;
    while (index > 0 && !this.isWordChar(word.charAt(index - 1))) {
      index -= 1;
    }

    return {
      cleanWord: word.slice(0, index),
      trailingPunctuation: word.slice(index),
    };
  }

  transform(value: string, capitalizeParentheses = false): string {
    if (!value) { return ''; }

    return value
      .toString()
      .trim()
      .split(' ')
      .map(word => {
        if (!word) { return ''; }

        const { cleanWord, trailingPunctuation } = this.splitTrailingPunctuation(word);

        // Special case for 'ID' whole word
        if (cleanWord.toLowerCase() === 'id') { return 'ID' + trailingPunctuation; };

        // Special case for 'OEM' whole word
        if (cleanWord.toLowerCase() === 'oem') { return 'OEM' + trailingPunctuation; };
 
        // Handle parentheses with capitalization option
        const match = cleanWord.match(/^\(([^)]+)\)$/); 
        if (match && capitalizeParentheses) {
          return `(${match[1].toUpperCase()})` + trailingPunctuation;
        }
 
        // Handle other special acronyms
        const lowerWord = cleanWord.toLowerCase();
        if (lowerWord === 'roi') { return 'ROI' + trailingPunctuation; };
        if (lowerWord === 'pc') { return 'PC' + trailingPunctuation; };
        if (lowerWord === 'pc?') { return 'PC?' + trailingPunctuation; };
        if (lowerWord === 'hq') { return 'HQ' + trailingPunctuation; };
        if (lowerWord === 'tci') { return 'TCI' + trailingPunctuation; };
        if (lowerWord === 'ase') { return 'ASE' + trailingPunctuation; };
        if (lowerWord === 't-ten') { return 'T-TEN' + trailingPunctuation; };
        if (lowerWord === 'ase-lexus') { return 'ASE-Lexus' + trailingPunctuation; };
        if (lowerWord === 'tmnahq-lx') { return 'TMNAHQ-LX' + trailingPunctuation; };
        
 
        // Camel case each segment separated by '-' or '/' (e.g., "event-registration/summary" -> "Event-Registration/Summary")
        return cleanWord
          .split(/([-/])/)
          .map(token => {
            if (token === '-' || token === '/') { return token; }
            if (!token) { return ''; }
            if (token.toLowerCase() === 'tmnahq') { return 'TMNAHQ'; }
            return token.charAt(0).toUpperCase() + token.slice(1).toLowerCase();
          })
          .join('') + trailingPunctuation;
      })
      .join(' ');
  }
}